import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["leaderSection", "roleSelect"]

  connect() {
    this.toggleLeaderSection()
  }

  toggleLeaderSection() {
    const isLeader = this.roleSelectTarget.value === "leader"
    isLeader
      ? this.leaderSectionTarget.classList.remove("hidden")
      : this.leaderSectionTarget.classList.add("hidden")
  }
}
